import React, { useState, useEffect } from 'react';
import FormKeyword from './form-keyword';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string'
import { FormSystem } from './form-sidebar-system';
import { useInternationalization } from '../../i18n';
import QueryProvider from '../hooks/provider';
import FormLocation from './form-sidebar-location';
import { DateFilter, BasicDropdown, SelectCheckbox } from '../../../components';
import { useSystem } from '../../system/hook';
import { formUpdater, inputNormalizer } from '../../../utils';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { convertOptionsToIds } from '../../../components/dashboard-listing/filter-form'

let flag = false

const SearchForm = ({
  options = {
    keyword: true,
    location: true,
    type: true,
    date: true,
    category: false,
    category_resource: false,
    type_resource: false,
  }
}) => {
  const [form, setForm] = useState({})
  const history = useHistory()
  const location = useLocation()
  const { search, pathname } = useLocation()
  const { translate } = useInternationalization()
  const {
    categoryBlogOptions,
    categoryResourceOptions,
    typeResourceOptions,
  } = useSystem()
  const { selectedAudienceId } = useSelector(state => state.system)

  const updateForm = (e) => formUpdater(e, form, setForm)

  const handleKeyword = (keyword) => {
    if(keyword && keyword.length > 0){
      const query = qs.parse(search)
      const newQuery = {
        ...query,
        keyword
      }
      history.push({
        pathname,
        search: qs.stringify(newQuery)
      })
    } else {
      const query = qs.parse(search)
      if (query.title) delete query.title
      if (query.keyword) delete query.keyword

      history.push({
        pathname,
        search: qs.stringify(query)
      })
    }
  }

  const handleMulti = (e, key) => {
    flag = true

    if(e === null){
      inputNormalizer([], key, updateForm)
    } else {
      // const ids = e.map(s => s.id ? s.id : s.value)
      const ids = e
      inputNormalizer(ids, key, updateForm)
    }
  }

  const handleFormChange = useCallback((form) => {
    const formIds = convertOptionsToIds(form)

    // Inject 'typeAudience'
    if(selectedAudienceId && selectedAudienceId !== 1 && !formIds.audience){
      formIds.audience = [selectedAudienceId]
    }

    const searchString = qs.stringify(formIds)
    const currentPath = location.pathname

    history.replace({
      pathname: currentPath,
      search: '?'+searchString
    })
  }, [history, location, selectedAudienceId])

  const handleDate = ({maxDate, minDate}) => {
    console.log({maxDate, minDate})
    if(maxDate && minDate){
      const query = qs.parse(search)
      const newQuery = {
        ...query,
        startRentangWaktu: minDate,
        endRentangWaktu: maxDate
      }

      history.push({
        pathname: '/search',
        search: qs.stringify(newQuery)
      })
    }
  }

  useEffect(() => {
    if(flag === true){
      flag = false
      handleFormChange(form)
    }
  }, [form, handleFormChange])

  return (
    <>
      {
        options.keyword &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'search_by_keyword')}
          </p>
          <FormKeyword onSubmit={handleKeyword}/>
        </div>
      }

      {
        options.category &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'categories')}
          </p>
          <BasicDropdown
            placeholder={translate('SEARCH', 'categories')}
            multi
            options={categoryBlogOptions}
            value={form.category || []}
            onChange={(e) => handleMulti(e, 'category')}
          />
        </div>
      }

      {
        options.category_resource &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'categories')}
          </p>
          <BasicDropdown
            placeholder={translate('SEARCH', 'categories')}
            multi
            options={categoryResourceOptions}
            value={form.category || []}
            onChange={(e) => handleMulti(e, 'category')}
          />
        </div>
      }

      {
        options.location &&
        <FormLocation />
      }

      <QueryProvider>
        <FormSystem />
      </QueryProvider>

      {
        options.type_resource &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'resource_type')}
          </p>
          {
            (typeResourceOptions && typeResourceOptions.length > 0) &&
            <SelectCheckbox
              className="text-sm"
              options={typeResourceOptions}
              value={form.typeResource || []}
              placeholder={translate('SEARCH', 'resource_type')}
              onChange={(e) => handleMulti(e, 'typeResource')}
            />
          }
        </div>
      }

      {
        options.date &&
        <div className="mb-8">
          <p className="font-bold text-sm mb-4">
            {translate('SEARCH', 'date')}
          </p>
          <div className="date-filter-wrapper relative">
            <DateFilter onSubmit={handleDate}/>
          </div>
        </div>
      }
    </>
  )
}

export default SearchForm
